import dayjs from '@aqx-core/common/dayjs';

import { TAppLanguageISOCountryCode } from './types';

export const changeDayLocale = (language: TAppLanguageISOCountryCode) => {
  switch (language) {
    case 'en_GB':
      dayjs.locale('en');
      break;
    case 'zh_CN':
      dayjs.locale('zh-cn');
      break;
    case 'zh_TW':
      dayjs.locale('zh-tw');
      break;
    case 'th_TH':
      dayjs.locale('th');
      break;
    case 'vi_VN':
      dayjs.locale('vi');
      break;
    case 'ms_MY':
      dayjs.locale('ms-my');
      break;
    case 'id_ID':
      dayjs.locale('id');
      break;
    case 'ja_JP':
      dayjs.locale('ja');
      break;
    case 'ko_KR':
      dayjs.locale('ko');
      break;
    case 'ar_AE':
      dayjs.locale('ar');
      break;
    case 'es_ES':
      dayjs.locale('es');
      break;
    case 'pt_BR':
      dayjs.locale('pt-br');
      break;
  }
};

export const getDayLocale = (language: TAppLanguageISOCountryCode) => {
  switch (language) {
    case 'zh_CN':
      return 'zh-cn';
    case 'zh_TW':
      return 'zh-tw';
    case 'th_TH':
      return 'th';
    case 'vi_VN':
      return 'vi';
    case 'ms_MY':
      return 'ms-my';
    case 'id_ID':
      return 'id';
    case 'ja_JP':
      return 'ja';
    case 'ko_KR':
      return 'ko';
    case 'ar_AE':
      return 'ar';
    case 'es_ES':
      return 'es';
    case 'pt_BR':
      return 'pt-br';
    default:
      return 'en';
  }
};
